export default __webpack_public_path__ + "static/media/black.033addc4.svg";